import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PricingNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goHome = () => {
    navigate('/');
    setMenuOpen(false);
  };

  const goHomeSection = (id: string) => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#F7F6FF]/90 backdrop-blur-xl border-b border-[#AFA9EC]/20'
          : 'bg-[#F7F6FF]/90 backdrop-blur-xl border-b border-[#AFA9EC]/20'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <button onClick={goHome} className="flex items-center gap-0 cursor-pointer">
          <span className="font-title text-2xl leading-none text-[#0A0A0A]">Cover</span>
          <span className="font-title text-2xl leading-none" style={{ color: '#AFA9EC' }}>ly</span>
        </button>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Cómo funciona', id: 'como-funciona' },
            { label: 'Planes', id: 'planes' },
            { label: 'FAQ', id: 'faq' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => goHomeSection(item.id)}
              className="text-sm font-medium text-[#0A0A0A]/70 hover:text-[#534AB7] transition-colors duration-300 whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <span className="text-sm font-semibold text-[#534AB7] whitespace-nowrap border-b-2 border-[#534AB7] pb-0.5">
            Precios
          </span>
        </div>



        {/* Mobile hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl text-[#534AB7] ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-[#F7F6FF]/97 backdrop-blur-xl transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-80 border-t border-[#AFA9EC]/20' : 'max-h-0'
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'Cómo funciona', id: 'como-funciona' },
            { label: 'Planes', id: 'planes' },
            { label: 'FAQ', id: 'faq' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => goHomeSection(item.id)}
              className="text-left text-[#0A0A0A]/70 font-medium py-2 border-b border-[#AFA9EC]/30 hover:text-[#534AB7] transition-colors"
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://wa.me/526675680042"
            target="_blank"
            rel="nofollow noreferrer"
            className="bg-[#534AB7] text-white font-semibold px-6 py-3 rounded-full mt-2 whitespace-nowrap text-center"
          >
            Quiero mi membresía
          </a>
        </div>
      </div>
    </nav>
  );
}
